export const convertFileSize = (bytes: number) => {
  if (bytes < 1000000) {
    return Math.floor(bytes / 1000) + 'KB'
  }
  return Math.floor(bytes / 1000000) + 'MB'
}
